@if (isLoading()) {
  <div class="bg-white border d-flex flex-column mh-100 overflow-hidden rounded-4 shadow-sm">
    <!-- Header Skeleton -->
    <div class="d-flex align-items-center justify-content-between p-3">
      <div class="d-flex align-items-center gap-2">
        <p-skeleton width="8rem" height="1.75rem"></p-skeleton>
        <p-skeleton width="5rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
      </div>
    </div>

    <!-- Accordion Sections Skeleton -->
    <div class="flex-fill overflow-y-auto p-2">
      <!-- Basic Details Accordion Skeleton (Expanded) -->
      <div class="rounded-4 overflow-hidden border m-2 mb-3">
        <div class="bg-light p-3 d-flex align-items-center justify-content-between">
          <p-skeleton width="8rem" height="1.25rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
        <div class="p-3">
          <!-- Location Field -->
          <div class="mb-3">
            <p-skeleton width="6rem" height="1rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="0.875rem"></p-skeleton>
          </div>

          <!-- Test Attribute 2 Field -->
          <div class="mb-3">
            <p-skeleton width="9rem" height="1rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="2.5rem" borderRadius="0.375rem"></p-skeleton>
          </div>

          <!-- Test Attribute Field -->
          <div class="mb-3">
            <p-skeleton width="8rem" height="1rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="2.5rem" borderRadius="0.375rem"></p-skeleton>
          </div>

          <!-- Unit of Measurement Field -->
          <div class="mb-3">
            <p-skeleton width="11rem" height="1rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="2.5rem" borderRadius="0.375rem"></p-skeleton>
          </div>

          <!-- Option Notes Field -->
          <div class="mb-3">
            <p-skeleton width="8rem" height="1rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="6rem" borderRadius="0.375rem"></p-skeleton>
          </div>

          <!-- Save Button -->
          <div class="d-flex justify-content-center">
            <p-skeleton width="10rem" height="2.5rem" borderRadius="1.5rem"></p-skeleton>
          </div>
        </div>
      </div>

      <!-- Pricing & Discounts Accordion Skeleton (Collapsed) -->
      <div class="rounded-4 overflow-hidden border m-2 mb-3">
        <div class="bg-light p-3 d-flex align-items-center justify-content-between">
          <p-skeleton width="12rem" height="1.25rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
      </div>

      <!-- Tax Information Accordion Skeleton (Collapsed) -->
      <div class="rounded-4 overflow-hidden border m-2">
        <div class="bg-light p-3 d-flex align-items-center justify-content-between">
          <p-skeleton width="10rem" height="1.25rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="bg-white border d-flex flex-column mh-100 overflow-hidden rounded-4 shadow-sm">
    <div class="d-flex align-items-center justify-content-between p-3">
      <div class="d-flex align-items-center gap-2">
        <h2 class="fs-20 mb-0">
          {{ product().productCode }}
        </h2>
        @if (product().productTypeName) {
          <span class="badge border fw-500 text-body-secondary border-dark-subtle">{{
            product().productTypeName
          }}</span>
        }
      </div>
    </div>
    <div class="flex-fill overflow-y-auto">
      <p-accordion [multiple]="true" [value]="['0', '1', '2']" class="options-sidebar">
        <p-accordion-panel value="0">
          <div class="rounded-4 overflow-hidden border selected-product-panel m-2">
            <p-accordion-header>
              <div class="d-flex flex-column flex-fill gap-2">
                <div class="d-flex align-items-center w-100 gap-2">
                  <h6 class="m-0 fs-18 fw-500">Basic Details</h6>
                </div>
              </div>
            </p-accordion-header>
            <p-accordion-content class="d-block">
              <deal-addendum-option-basic-details-form
                [dealAddendum]="dealAddendum()"
                [addendumOption]="product()!"
                (onChanges)="onBasicDetailsChanges()"
              />
            </p-accordion-content>
          </div>
        </p-accordion-panel>
        @if (!isKitLinkedProduct()) {
          <p-accordion-panel value="1">
            <div class="rounded-4 overflow-hidden border selected-product-panel m-2">
              <p-accordion-header>
                <div class="d-flex flex-column flex-fill gap-2">
                  <div class="d-flex align-items-center w-100 gap-2">
                    <h6 class="m-0 fs-18 fw-500">Pricing & Discounts</h6>
                  </div>
                </div>
              </p-accordion-header>
              <p-accordion-content class="d-block">
                <lib-deal-pricing-discount
                  [buyerAndBuilderApproved]="dealAddendum().isLocked"
                  [addendumOption]="product()!"
                  (discountUpdated)="onTaxInformationChanges()"
                  [isCancelled]="dealAddendum().isCancelled"
                />
              </p-accordion-content>
            </div>
          </p-accordion-panel>
          <p-accordion-panel value="2">
            <div class="rounded-4 overflow-hidden border selected-product-panel m-2">
              <p-accordion-header>
                <div class="d-flex flex-column flex-fill gap-2">
                  <div class="d-flex align-items-center w-100 gap-2">
                    <h6 class="m-0 fs-18 fw-500">Tax Information</h6>
                  </div>
                </div>
              </p-accordion-header>
              <p-accordion-content class="d-block">
                <lib-deal-tax-information
                  [buyerAndBuilderApproved]="dealAddendum().isLocked"
                  [addendumProductId]="addendumProductId()"
                  [addendumProductTaxes]="product().taxes"
                  [category]="product().taxCategory"
                  (reload)="onTaxInformationChanges()"
                  [isCancelled]="dealAddendum().isCancelled"
                ></lib-deal-tax-information>
              </p-accordion-content>
            </div>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </div>
}
